import React from 'react';
import CheckCircleButton from './CheckCircleButton';

//= ========================================================================

const StepIndicatorButton = ({
  title,
  onCirclePressed,
  stepIndex,
  index,
  isHollow,
}) => {
  const isDisabled = onCirclePressed === undefined || index === stepIndex;
  const drawHollow = isHollow && stepIndex === index;

  return (
    <CheckCircleButton
      title={title}
      onPress={() => {
        onCirclePressed(index);
      }}
      isHollow={!drawHollow}
      isBlue={stepIndex >= index}
      isDisabled={isDisabled}
    />
  );
};

export default StepIndicatorButton;
